import React, { useContext, useRef, useState } from 'react';
import { Row, Col, Card } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { ActionButton, DefaultButton, IconButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import CLabel from '../../../../../Common/CLabel';
import { Checkbox, DirectionalHint, Dropdown, Toggle, TooltipHost } from '@fluentui/react';
import { __CONTRACTUAL, __enum_PageMode, __MessageTypes, enum__PRIVILEGES } from '../../../../../../common/Dictionaries';
import { addDataserieElementTags, updateDataserie } from '../../../../../../services/sKPI/dataserie.service';
import { _global_buttonStyles } from '../../../../../../common/ObjectStructures/Trasnversal';
import { isNullOrEmpty, isNullUndefined, isNullUndefinedOrEmpty, showMessage } from '../../../../../../common/Helpers';
import MessageBox from '../../../../../Common/Message/MessageBox';
import PropTypes from 'prop-types';
import CDatePicker from '../../../../../Common/CDatePicker';
import { useGetObjetives } from '../../../../../../hooks/services/sKPI/useOfObjetive';
import CValidator from '../../../../../Common/CValidator';
import { useDispatch, useSelector } from 'react-redux';
import { action_updateBoardDataserie } from '../../../../../../reducers/actions/KPI/actions';
import AditionalInfoCard from '../BoardList/AditionalInfoCard';
import { useGetPrivilegeRolesElementsDropDown } from '../../../../../../hooks/services/sPrivilege/useOfPrivilege';
import DataserieDocumentBox from './DataserieDocumentBox';
import JqxNumberInput from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxnumberinput';
import { _checkSecurityUser_And_ResponsibleInsert } from '../../../../../../common/Helpers/HLP_Security';
import MainAppContext from '../../../../../../MainAppContext';
import BoardAppContext from '../../../../../../BoardAppContext';
import CTextBox from '../../../../../Common/CTextBox';
import { useGetDataserieTag } from '../../../../../../hooks/services/sKPI/useOfDataSerie';

const SidePanelViewDataserieAditionalInfo = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { 
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_DataSerie = null,
        inputParam_SetterDataSerie = null,
        inputParam_ElementId = null,
        inputParam_UserProps = null,
    } = props;

    const { _boardElementRoles: boardElementRoles } = useSelector((state) => state.boardViewComponentsScope);
    const { _systemRoles: systemRoles } = useSelector((state) => state.boardViewComponentsScope);

    const contextSite = useContext(MainAppContext);
    const contextBoard = useContext(BoardAppContext);

    const aux_userProps = !isNullUndefined(inputParam_UserProps) ? inputParam_UserProps : contextBoard.userPropsKpi.value;

    const _priv_canManipulateSelectedElement = _checkSecurityUser_And_ResponsibleInsert(inputParam_DataSerie.responsibleInsertRole, contextSite.onlyObserver, aux_userProps, contextSite.securityProps, inputParam_DataSerie.elementId, enum__PRIVILEGES.GAP_CONTRACT_APROVE, boardElementRoles, systemRoles)

    const canEdit = (_priv_canManipulateSelectedElement.value && _priv_canManipulateSelectedElement.mode === __enum_PageMode.Edit)

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    const [isValidForm, setIsValidForm] = useState({
        beginDate: true,
        endDate: true,
        contractual: true,
        dataserieId: true,
        responsibleInsertRole: true,
    });

    const [documentLinkList, setDocumentLinkList] = useState(null);
    const [tagItems, setTagItems] = useState(null);
    const [tagItemsArray, setTagItemsArray] = useState(null);
    
    
    const [newTagText, setNewTagText] = useState("")
    const [goalDefault, setGoalDefault] = useState(isNullUndefinedOrEmpty(inputParam_DataSerie.goal))
    
    const [objDataserieInfo, setObjDataserieInfo] = useState(inputParam_DataSerie)
    const [selectedElementRole, setSelectedElementRole] = useState(null);
    const [elementRoleList, setElementRoleList] = useState(null);
    useGetPrivilegeRolesElementsDropDown(inputParam_DataSerie.elementId, elementRoleList, setElementRoleList, inputParam_IsPanelOpen, objDataserieInfo.responsibleInsertRole, setSelectedElementRole);

    useGetDataserieTag(inputParam_DataSerie.dataserieId, tagItemsArray, setTagItemsArray, tagItems, setTagItems);

    const [listObjetives, setListObjetives] = useState(null);
    useGetObjetives(listObjetives, setListObjetives)

    const setterObjDataserieInfo = (value, controlIdAsField) => {
        setObjDataserieInfo(prevState => ({
            ...prevState,
            [controlIdAsField]: value,
        }));
    }

    const onChangeContractual = (control, option) => {
        setterObjDataserieInfo(option.key, "contractual")
    }

    const setterNewTagText = (controlValue) => {
        setNewTagText(controlValue)
    }

    const onSaveTagItems = async () => {
        tagItems.tags = tagItemsArray.join(";")
        
        await addDataserieElementTags(tagItems).then((response) => {
            if (response.data.succeeded) {
                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    }

    const onAddTagItems = () => {
        let items = [...tagItemsArray];
        items.push(newTagText.replace(/[^a-zA-Z0-9]/g, ''));
        setTagItemsArray(items)
        setNewTagText('')
    }

    const onChangeGoal = (value) => {
        setterObjDataserieInfo(value, "goal")
    }

    const validateForm = () => {
        let isValid =(
            objDataserieInfo.contractual !== null &&
            objDataserieInfo.dataserieId !== null
        ) ? true : false;


        isValidForm.contractual = !isNullUndefinedOrEmpty(objDataserieInfo.contractual)
        isValidForm.dataserieId = !isNullUndefinedOrEmpty(objDataserieInfo.dataserieId)
        //isValidForm.responsibleInsertRole = !isNullUndefinedOrEmpty(objDataserieInfo.responsibleInsertRole)
           
        setIsValidForm(isValidForm)

        return isValid
    }

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        showMessage(setMessageConfig, false, null, null)
        setDocumentLinkList(null)
        
        setIsValidForm({
            beginDate: true,
            endDate: true,
            contractual: true,
            dataserieId: true,
            responsibleInsertRole: true,
        });
    };

    const onEditItem = () => {
        if (validateForm()) { 
            const objNew = {
                id: objDataserieInfo.dataserieId,
                dataserieCode: objDataserieInfo.dataserieCode,
                variableId: objDataserieInfo.variableId,
                elementId: objDataserieInfo.elementId,
                beginDate: objDataserieInfo.beginDate,
                endDate: objDataserieInfo.endDate,
                contractual: objDataserieInfo.contractual,
                responsibleInsertRole: objDataserieInfo.responsibleInsertRole,
                privilegeRoleId: null,//Agregar aqui el id del rol.
                goal: (goalDefault === true) ? null : objDataserieInfo.goal,
            }

            updateDataserie(objDataserieInfo.dataserieId, objNew).then((response) => {
                if (response.data.succeeded) {
                    
                    inputParam_DataSerie.responsibleInsertRole = objNew.responsibleInsertRole;
                    inputParam_DataSerie.beginDate = objNew.beginDate;
                    inputParam_DataSerie.contractual = objNew.contractual;
                    inputParam_DataSerie.endDate = objNew.endDate;
                    inputParam_DataSerie.goal = objNew.goal;
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))

                    inputParam_SetterDataSerie && inputParam_SetterDataSerie(prevState => ({
                        ...prevState,
                        responsibleInsertRole: objNew.responsibleInsertRole,
                        beginDate: objNew.beginDate,
                        contractual: objNew.contractual,
                        endDate: objNew.endDate,
                        goal: objNew.goal
                    }))

                    try {
                        dispatch(action_updateBoardDataserie(inputParam_DataSerie, true)) 
                    } catch (error) {
                    }
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-requireddatanotset'))
        }
    };

    const onClickRole = (itemId) => {
        let obj = elementRoleList.find(element => element.id === itemId);
        if (obj !== undefined) { 
            obj.selected = true
            setSelectedElementRole(obj)
        };

        setObjDataserieInfo(prevState => ({
            ...prevState,
            responsibleInsertRole: obj.code
        }));

        setIsValidForm(prevState => ({
            ...prevState,
            responsibleInsertRole: obj !== undefined,
        }));

        showMessage(setMessageConfig, false, null, null)
    }
    const onGoalDefaultChanged = (ev, checked) => {
        setGoalDefault(checked);
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };
    const onDeleteTagItem = (text) => {
        setTagItemsArray(tagItemsArray.filter(x => x !== text))
    };
    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        {
                            canEdit &&
                            <PrimaryButton onClick={ onEditItem } styles={_global_buttonStyles}>{ t('data-lang-btn-save') }</PrimaryButton>
                        }
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    const renderTagItem = (text) => {
        return <Card>
                    <Card.Body>
                        <Row>
                            <Col><p>{text}</p></Col>
                            <Col className='col-auto me-auto'><IconButton iconProps={{iconName: "Delete"}} onClick={() => onDeleteTagItem(text)} /></Col>
                        </Row>
                    </Card.Body>
                </Card>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-dataserieinfo') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <div className='pt-5'>
                    <AditionalInfoCard
                        inputParam_DataSerie={inputParam_DataSerie}
                        inputParam_ListObjetives={listObjetives}
                        inputParam_ShowDescription={true}
                    />
                </div>
                <Row className="pt-3">
                    {
                        canEdit &&
                        <Col className="mt-3">
                            <Row>
                                <Col className='pe-0'>
                                    <Dropdown
                                        label={t('data-lang-lbl-responsibleinsert')}
                                        options={ elementRoleList !== null ? elementRoleList : [] }
                                        selectedKey={selectedElementRole ? selectedElementRole.id : null}
                                        onRenderOption={(option) => <div className="cursor-pointer" onClick={() => onClickRole(option.id)}>
                                            <div>{option.name}</div>
                                        </div>}
                                    />
                                    <CValidator isInValid={ !isValidForm.responsibleInsertRole } />
                                </Col>
                                <Col className='ps-0 col-auto me-auto mt-auto'>
                                    <TooltipHost content={t('data-lang-btn-clear')} directionalHint={DirectionalHint.rightCenter}>
                                        <ActionButton className="float-end" onClick={() => onClickRole(0)} iconProps={{ iconName: 'Clear' }} allowDisabledFocus disabled={false} checked={false} />
                                    </TooltipHost>
                                </Col>
                            </Row>
                            
                        </Col>
                    }
                    {
                        !canEdit &&
                        <Col className='pe-0'>
                            <CLabel aditionalStyles={{display: "contents"}} labelText={ `${t('data-lang-lbl-responsibleinsert')}` } labelValue={selectedElementRole ? selectedElementRole.name : t('no-data') }  />
                        </Col>
                    }
                </Row>
                <Row className="pt-3">
                    <Col>
                        {
                            canEdit &&
                            <Row>
                                <Col className='pe-0'>
                                    <CDatePicker disabled={!canEdit} controlName={"beginDate"} controlValue={ objDataserieInfo.beginDate } setterControlValue={ setterObjDataserieInfo } isInValid={ !isValidForm.beginDate } labelText={ `${t('data-lang-lbl-startdate')}:` } />
                                </Col>
                                <Col className='ps-0 col-auto me-auto mt-auto'>
                                    <TooltipHost content={t('data-lang-btn-clear')} directionalHint={DirectionalHint.rightCenter}>
                                        <ActionButton className="float-end" onClick={() => setterObjDataserieInfo(null, "beginDate")} iconProps={{ iconName: 'Clear' }} allowDisabledFocus disabled={false} checked={false} />
                                    </TooltipHost>
                                </Col>
                            </Row>
                        }
                        {
                            !canEdit &&
                            <Row>
                                <Col className='pe-0'>
                                    <CLabel aditionalStyles={{display: "contents"}} labelText={ `${t('data-lang-lbl-startdate')}` } labelValue={ !isNullUndefinedOrEmpty(objDataserieInfo.beginDate) ? objDataserieInfo.beginDate : t('no-data') }  />
                                </Col>
                            </Row>
                        }
                    </Col>
                    <Col>
                        {
                            canEdit &&
                            <Row>
                                <Col className='pe-0'>
                                    <CDatePicker disabled={!canEdit} controlName={"endDate"} controlValue={ objDataserieInfo.endDate } setterControlValue={ setterObjDataserieInfo } isInValid={ !isValidForm.endDate } labelText={ `${t('data-lang-lbl-enddate')}:` } />
                                </Col>
                                <Col className='ps-0 col-auto me-auto mt-auto'>
                                    <TooltipHost content={t('data-lang-btn-clear')} directionalHint={DirectionalHint.rightCenter}>
                                        <ActionButton className="float-end" onClick={() => setterObjDataserieInfo(null, "endDate")} iconProps={{ iconName: 'Clear' }} allowDisabledFocus disabled={false} checked={false} />
                                    </TooltipHost>
                                </Col>
                            </Row>
                        }
                        {
                            !canEdit &&
                            <Row>
                                <Col>
                                    <CLabel aditionalStyles={{display: "contents"}} labelText={ `${t('data-lang-lbl-enddate')}:` } labelValue={ !isNullUndefinedOrEmpty(objDataserieInfo.endDate) ? objDataserieInfo.endDate : t('no-data') }  />
                                </Col>
                            </Row>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col className='pe-0'>
                        <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-goal') }  />
                        {
                            canEdit &&
                            <Row>
                                <Col xl={6} className='pe-0'>
                                    <JqxNumberInput
                                        max={999999999999999}
                                        allowNull={true}
                                        width={"100%"}
                                        height={25}
                                        inputMode="simple"
                                        maxLength="25"
                                        symbolPosition={'right'}
                                        digits={15}
                                        decimalDigits={5}
                                        value={ goalDefault === true ? objDataserieInfo.goalMaster : objDataserieInfo.goal}
                                        groupSeparator= ','
                                        decimalSeparator= '.'
                                        onChange={(event) => onChangeGoal(event.args.value)}
                                        disabled={goalDefault === true}
                                    />
                                </Col>
                                <Col xl={6} className='ps-0 col-auto me-auto mt-auto'>
                                    <Checkbox className='p-1' label={t('data-lang-lbl-defaultgoal')} checked={goalDefault} onChange={(ev, checked) => onGoalDefaultChanged(ev, checked)} />
                                </Col>
                            </Row>
                        }
                        {
                            !canEdit &&
                            <CLabel aditionalStyles={{display: "contents"}} labelValue={ objDataserieInfo.goal }  />
                        }
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-contractual') }  />
                        {
                            canEdit &&
                            <Dropdown
                                id={`ddlContractual${objDataserieInfo.dataserieId}`}
                                placeholder={t('data-lang-placeholder-selectoption')}
                                options={ __CONTRACTUAL.map(({ key, title, text }) => {return {key: key, title: t(title), text: t(text) }}) }
                                selectedKey={objDataserieInfo.contractual}
                                onChange={ onChangeContractual }
                                styles={ {title: { height: "32px" }} }
                                className="pt-2"
                                errorMessage={!isValidForm.contractual ? t('data-lang-msg-required') : undefined}
                                required={true}
                                disabled={!canEdit}
                            />
                        }
                        {
                            !canEdit &&
                            <CLabel aditionalStyles={{display: "contents"}} labelValue={ objDataserieInfo.contractual ? t('data-lang-lbl-yes') : t('data-lang-lbl-no') }  />
                        }
                    </Col>
                </Row>
                {
                    tagItemsArray &&
                    <Row>
                        <Col className='border rounded'>
                            <h4 className='border-bottom'>Tags</h4>
                            <Row>
                                <Col>
                                    <CTextBox labelText={t('data-lang-lbl-addtag')} controlValue={newTagText} setterControlValue={setterNewTagText} editMode={canEdit} />
                                </Col>
                                <Col className='col-auto me-auto'>
                                    <ActionButton onClick={onAddTagItems} iconProps={{ iconName: 'Add' }} allowDisabledFocus>{t('data-lang-btn-add')}</ActionButton>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    tagItemsArray && tagItemsArray.map(tagText => (
                                        <Col xl={6}>
                                            {renderTagItem(tagText)}
                                        </Col>
                                    ))
                                }
                            </Row>
                            <Row>
                                <Col></Col>
                                <Col className='col-auto me-auto'>
                                    <ActionButton onClick={onSaveTagItems} iconProps={{ iconName: 'Save' }} allowDisabledFocus>{t('data-lang-btn-save')}</ActionButton>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                }
                {
                    inputParam_DataSerie &&
                    <DataserieDocumentBox
                        inputParam_IsPanelOpen={inputParam_IsPanelOpen}
                        inputParam_ObjDataserieId={inputParam_DataSerie.dataserieId}
                        inputParam_SetMessageConfig={setMessageConfig}
                        inputParam_EditMode={canEdit}    
                        inputParam_DocumentLinkList={documentLinkList}
                        inputParam_SetDocumentLinkList={setDocumentLinkList}
                    />
                }
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelViewDataserieAditionalInfo.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_DataSerie: PropTypes.object.isRequired,
    inputParam_SetterDataSerie: PropTypes.func.isRequired,
};

export default SidePanelViewDataserieAditionalInfo;